export const getColor = (index: number) => {
  const colors = [
    '#6ACFD5',
    '#F59B8D',
    '#AE9DD4',
    '#F1BE68',
    '#99CEAC',
    '#D19CCB',
    '#80A9CB',
    '#DAA980',
    '#9BE7B6',
    '#F5CBF1',
    '#90C8F7',
    '#F4CBA9',
    '#CDF4DB',
    '#F0DDEE',
    '#C1DFF8',
    '#F3E1D2',
  ];
  if (index < colors.length) {
    return colors[index];
  } else {
    return (
      '#' +
      Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, '0')
    );
  }
};
